class Header {

    static name() {
        return 'Header';
    }

    constructor(props, el, $, Utils) {

        const objects = {
            $el: $(el),
            $nav: $(el).find('.navbar'),
            $navbarCollapse: $(el).find('.navbar-collapse'),
            $navLink: $(el).find('a[data-target]'),
            $navList: $(el).find('ul.navbar-nav'),
            $activeLink: $(el).find('.nav-link.is-active'),
            $parentLinks: $(el).find('.nav-link[data-level]'),
            $backbtn: $(el).find('.btn-back'),
            $backbtnIcon: $(el).find('.btn-back .icon'),
            $closebtn: $(el).find('.btn-close'),
            $headerSearch: $(el).find('.search.form-inline'),
            $searchInput: $(el).find('.search .form-control'),
            $searchCategories: $(el).find('a[data-category]'),
            $textareas: $('textarea'),
            $menuDialogDropdown: $(el).find('.dropdown-menu'),
            $menuDialog: $(el).find('.dropdown-menu.parent'),
        };


        let utils = new Utils();
        let desktopDropdownTimer = null;
        let desktopCloseTimer = null;
        let desktopMenuGapBounds = null; 


        this.isMobileNav = () => {
            return (
                utils.getViewportSize() === 'xs' ||
                utils.getViewportSize() === 'sm' ||
                utils.getViewportSize() === 'md'
            );
        };
        
        let lastIsMobileNav = this.isMobileNav();
        let resizeReconcileTimer = null;
        
        // Desktop's open-panel state (is-active, inline max-height, desktop-dropdown-open)
        // and mobile's accordion state (slideDown/slideUp inline styles, nav-offset,
        // data-current/data-previous) are two different animation systems that never
        // talk to each other. Neither tears itself down when the viewport just crosses
        // the breakpoint out from under it - only an explicit check catches that.
        this.reconcileNavStateOnResize = () => {
            const nowMobile = this.isMobileNav();
        
            if(nowMobile === lastIsMobileNav) {
                return;
            }
        
            if(nowMobile) {
                // Was desktop, now mobile: kill any open flyout's is-active/max-height
                // before the mobile accordion CSS/JS has to coexist with it.
                this.closeDesktopDropdownsImmediately();
            } else {
                // Was mobile, now desktop: same teardown the outside-click handler
                // already uses for the mobile case - closes the accordion, clears
                // slideDown's inline styles via resetAll's removeAttr('style'), and
                // collapses the side panel.
                this.removeOffset();
                $('#navbarSupportedContent').collapse('hide');
            }
        
            lastIsMobileNav = nowMobile;
        };
        
        $(window).on('resize', () => {
            // Bounds invalidation is cheap (just nulls a variable) - no need to debounce.
            this.invalidateDesktopMenuGapBounds();
        
            // Reconciliation tears down animated state and toggles Bootstrap collapse,
            // so it's debounced to run once after resizing settles, not per event.
            clearTimeout(resizeReconcileTimer);
            resizeReconcileTimer = setTimeout(() => {
                this.reconcileNavStateOnResize();
            }, 150);
        });
        
        this.clearDesktopDropdownTimer = () => {
            if(desktopDropdownTimer) {
                clearTimeout(desktopDropdownTimer);
                desktopDropdownTimer = null;
            }

            if(desktopCloseTimer) {
                clearTimeout(desktopCloseTimer);
                desktopCloseTimer = null;
            }
        };

        this.clearDesktopCloseTimer = () => {
            if(desktopCloseTimer) {
                clearTimeout(desktopCloseTimer);
                desktopCloseTimer = null;
            }
        };

        this.setActiveDesktopNavLink = ($activeLink) => {
            objects.$el
                .find('ul.navbar-nav > li.nav-item > a[data-target]')
                .removeClass('is-dropdown-active')
                .attr('aria-expanded', 'false');

            if($activeLink && $activeLink.length) {
                $activeLink
                    .addClass('is-dropdown-active')
                    .attr('aria-expanded', 'true');
            }
        };

        this.getDesktopDropdownHeight = ($dropdown) => {
            if(!$dropdown.length) {
                return 0;
            }


            return $dropdown[0].scrollHeight;
        };

        // The measured pixel height is only needed to animate the panel open. Once it
        // is open the height is handed back to the content so the panel keeps growing
        // when late content (lazy loaded images) changes its size.
        this.releaseDesktopDropdownHeight = ($dropdown) => {
            if(!$dropdown || !$dropdown.length) {
                return;
            }

            $dropdown.css('max-height', '');
        };

        // Images in the dropdown are lazy loaded, so on the first open they have no
        // height yet and the panel measures too short. Release the pinned height as
        // they arrive so the panel settles at its real content height.
        this.watchDesktopDropdownMedia = ($dropdown) => {
            if(!$dropdown.length) {
                return;
            }

            const $images = $dropdown.find('img');

            $images.off('.headerDropdown');

            const $pending = $images.filter(function() {
                // A lazy image has no src yet, and an img without a src reports
                // itself as complete, so check for the pending data attributes too.
                const isLazyPending = !this.getAttribute('src') &&
                    !this.getAttribute('srcset') &&
                    (this.getAttribute('data-src') || this.getAttribute('data-srcset'));

                return Boolean(isLazyPending) || !this.complete;
            });

            if(!$pending.length) {
                return;
            }

            $pending.on('load.headerDropdown error.headerDropdown', () => {
                if(this.isMobileNav()) {
                    return;
                }

                if(!$dropdown.hasClass('is-active') || $dropdown.hasClass('is-closing')) {
                    return;
                }

                this.releaseDesktopDropdownHeight($dropdown);
            });
        };

        this.closeDesktopDropdowns = () => {
            this.clearDesktopDropdownTimer();
            this.invalidateDesktopMenuGapBounds();
            
            const $activeDropdown = objects.$menuDialog.filter('.is-active');

            if(!$activeDropdown.length) {
                this.setActiveDesktopNavLink(null);

                objects.$navbarCollapse.removeClass('d-block');

                objects.$el.removeClass(
                    'desktop-dropdown-open desktop-dropdown-switching desktop-dropdown-closing'
                );

                objects.$menuDialog
                    .removeClass('is-active is-switching is-closing is-ready')
                    .css('max-height', '');

                return;
            }

            const currentHeight = $activeDropdown.outerHeight();

            $activeDropdown.find('img').off('.headerDropdown');

            objects.$el
                .removeClass('desktop-dropdown-switching')
                .addClass('desktop-dropdown-closing');

            $activeDropdown
                .removeClass('is-ready is-switching')
                .addClass('is-closing')
                .css('max-height', currentHeight + 'px');

            $activeDropdown[0].offsetHeight;

            requestAnimationFrame(() => {
                $activeDropdown.css('max-height', '0px');
            });

            desktopDropdownTimer = setTimeout(() => {
                $activeDropdown
                    .removeClass('is-active is-closing is-switching is-ready')
                    .css('max-height', '');

                this.setActiveDesktopNavLink(null);

                objects.$navbarCollapse.removeClass('d-block');

                objects.$el.removeClass(
                    'desktop-dropdown-open desktop-dropdown-switching desktop-dropdown-closing'
                );

                desktopDropdownTimer = null;
            }, 320);
        };

        this.closeDesktopDropdownsImmediately = () => {
            this.clearDesktopDropdownTimer();
            this.invalidateDesktopMenuGapBounds();

            objects.$menuDialog.find('img').off('.headerDropdown');

            objects.$menuDialog
                .removeClass('is-active is-switching is-closing is-ready')
                .css({
                    'max-height': '',
                    'transition': ''
                });
            
            this.setActiveDesktopNavLink(null);
            
            objects.$navbarCollapse.removeClass('d-block');

            objects.$el.removeClass(
                'desktop-dropdown-open desktop-dropdown-switching desktop-dropdown-closing'
            );
        };

        this.handleDesktopDropdown = (e) => {
            
            this.clearDesktopDropdownTimer();

            const $clickedLink = $(e.currentTarget);
            const targetSelector = $clickedLink.attr('data-target');
            const $targetDropdown = targetSelector ? $(targetSelector) : $();

            this.setActiveDesktopNavLink($clickedLink);

            if(!$targetDropdown.length) {
                return;
            }

            const $currentDropdown = objects.$menuDialog.filter('.is-active');
            const dropdownIsAlreadyOpen = objects.$el.hasClass('desktop-dropdown-open');
            const sameDropdownHovered = $currentDropdown.length && $currentDropdown.is($targetDropdown);

            if(sameDropdownHovered && !$targetDropdown.hasClass('is-closing')) {
                this.clearDesktopCloseTimer();
                return;
            }

            objects.$navbarCollapse.addClass('d-block');

            objects.$el
                .removeClass('desktop-dropdown-closing')
                .addClass('desktop-dropdown-open');

            $targetDropdown.removeClass('is-closing is-ready');

            if(dropdownIsAlreadyOpen && $currentDropdown.length && !$currentDropdown.is($targetDropdown)) {
            const currentHeight = $currentDropdown.outerHeight();

            objects.$el.addClass('desktop-dropdown-switching');

            $targetDropdown
                .addClass('is-active is-switching')
                .removeClass('is-closing is-ready')
                .css({
                    'transition': 'none',
                    'max-height': currentHeight + 'px'
                });

            $currentDropdown
                .removeClass('is-active is-switching is-ready is-closing')
                .css('max-height', '');

            $targetDropdown[0].offsetHeight;

            const targetHeight = this.getDesktopDropdownHeight($targetDropdown);

            requestAnimationFrame(() => {
                $targetDropdown.css({
                    'transition': '',
                    'max-height': targetHeight + 'px'
                });
            });

            this.watchDesktopDropdownMedia($targetDropdown);
            this.computeDesktopMenuGapBounds($targetDropdown);

            desktopDropdownTimer = setTimeout(() => {
                $targetDropdown
                    .removeClass('is-switching')
                    .addClass('is-ready')
                    .css('transition', '');

                this.releaseDesktopDropdownHeight($targetDropdown);

                objects.$el.removeClass('desktop-dropdown-switching');
                desktopDropdownTimer = null;
            }, 320);

            return;
        }

            objects.$menuDialog
                .removeClass('is-active is-switching is-closing is-ready')
                .css('max-height', '');

            $targetDropdown
                .addClass('is-active')
                .css('max-height', '0px');

            const targetHeight = this.getDesktopDropdownHeight($targetDropdown);

            $targetDropdown[0].offsetHeight;

            requestAnimationFrame(() => {
                $targetDropdown.css('max-height', targetHeight + 'px');
            });

            this.watchDesktopDropdownMedia($targetDropdown);
            this.computeDesktopMenuGapBounds($targetDropdown);

            desktopDropdownTimer = setTimeout(() => {
                $targetDropdown.addClass('is-ready');

                this.releaseDesktopDropdownHeight($targetDropdown);

                desktopDropdownTimer = null;
            }, 320);
        };

        this.scheduleDesktopClose = (delay) => {
            if(desktopCloseTimer) {
                return;
            }

            desktopCloseTimer = setTimeout(() => {
                desktopCloseTimer = null;
                this.closeDesktopDropdowns();
            }, typeof delay === 'number' ? delay : 350);
        };

        // The nav list holds more than the menu: authors can drop plain links into it
        // (the account/profile link, the mini search toggle) and those keep getting
        // added, so the menu is defined by what owns a dropdown panel rather than by
        // blacklisting whatever is currently sitting next to it.
        this.getDesktopMenuItems = () => {
            return objects.$navList
                .find('> li.nav-item')
                .filter(function() {
                    return $(this).children('a[data-target]').length > 0;
                });
        };

        // The menu stays open only while the pointer is on the menu itself. The panels
        // live inside their own top level item, so matching the item covers both the
        // trigger link and the open panel; anything else in the header closes the menu.
        this.isInsideDesktopMenu = ($target) => {
            const $item = $target.closest('ul.navbar-nav > li.nav-item');

            if(!$item.length) {
                return false;
            }

            return $item.children('a[data-target]').length > 0;
        };

        // Horizontal span of the top level menu items only. The nav items that are not
        // menu triggers have to be left out or the band below them would count as menu.
        // Taken as a single span so the gutters between the items are included.
        this.getDesktopMenuItemBounds = () => {
            const $items = this.getDesktopMenuItems();

            let left = Infinity;
            let right = -Infinity;
            let top = Infinity;

            $items.each(function() {
                const rect = this.getBoundingClientRect();

                // Items hidden at this breakpoint are not laid out
                if(!rect.width && !rect.height) {
                    return;
                }

                left = Math.min(left, rect.left);
                right = Math.max(right, rect.right);
                top = Math.min(top, rect.top);
            });

            if(left === Infinity) {
                return null;
            }

            return { left, right, top };
        };

        // Cached on dropdown open/switch; invalidated on resize/scroll since those are
        // the only things that can move the nav items or the panel. The panel's own
        // open/close height animation never touches these numbers, since we only read
        // its top edge, not its height.
        this.computeDesktopMenuGapBounds = ($activeDropdown) => {
            if(!$activeDropdown || !$activeDropdown.length) {
                desktopMenuGapBounds = null;
                return;
            }
        
            const itemBounds = this.getDesktopMenuItemBounds();
        
            if(!itemBounds) {
                desktopMenuGapBounds = null;
                return;
            }
        
            const panelRect = $activeDropdown[0].getBoundingClientRect();
        
            desktopMenuGapBounds = {
                left: itemBounds.left,
                right: itemBounds.right,
                top: itemBounds.top,
                panelTop: panelRect.top
            };
        };
        
        this.invalidateDesktopMenuGapBounds = () => {
            desktopMenuGapBounds = null;
        };
        
        this.isInsideDesktopMenuGap = (e) => {
            if(typeof e.clientX !== 'number' || typeof e.clientY !== 'number') {
                return false;
            }
        
            if(!desktopMenuGapBounds) {
                // Lazy recompute: only hit after an actual resize/scroll invalidation,
                // not on every mousemove.
                this.computeDesktopMenuGapBounds(objects.$menuDialog.filter('.is-active'));
            }
        
            if(!desktopMenuGapBounds) {
                return false;
            }
        
            return e.clientX >= desktopMenuGapBounds.left &&
                e.clientX <= desktopMenuGapBounds.right &&
                e.clientY >= desktopMenuGapBounds.top &&
                e.clientY <= desktopMenuGapBounds.panelTop;
        };
        this.handleDesktopOverlayHover = (e) => {
            if(this.isMobileNav()) {
                return;
            }

            if(!objects.$el.hasClass('desktop-dropdown-open')) {
                return;
            }

            const $target = $(e.target);

            if(this.isInsideDesktopMenu($target)) {
                this.clearDesktopCloseTimer();
                return;
            }

            // A plain link placed between two menu items sits inside the gap band, so
            // it has to be ruled out before the gap check or hovering it keeps the menu open.
            const isOnPlainNavItem = $target.closest('ul.navbar-nav > li.nav-item').length > 0;

            if(!isOnPlainNavItem && this.isInsideDesktopMenuGap(e)) {
                this.clearDesktopCloseTimer();
                return;
            }

            this.scheduleDesktopClose();
        };

        // Leaving the window (or the page losing focus) fires no mousemove, so the
        // hover handler above never gets a chance to close the dropdown.
        this.handleDesktopPointerLeave = (e) => {
            if(this.isMobileNav()) {
                return;
            }

            if(!objects.$el.hasClass('desktop-dropdown-open')) {
                return;
            }

            // A relatedTarget means the pointer is still inside the document.
            if(e && e.relatedTarget) {
                return;
            }

            this.scheduleDesktopClose(150);
        };
        
        this.handleDesktopFocusOut = (e) => {
            if(this.isMobileNav()) {
                return;
            }
        
            if(!objects.$el.hasClass('desktop-dropdown-open')) {
                return;
            }
        
            const $nextFocus = e.relatedTarget ? $(e.relatedTarget) : $();
        
            // No relatedTarget usually means focus left the document entirely
            // (e.g. to the address bar) - treat that the same as leaving the menu.
            if(!$nextFocus.length || !this.isInsideDesktopMenu($nextFocus)) {
                this.closeDesktopDropdowns();
            }
        };

        this.handleDesktopEscClose = (e) => {
            if(this.isMobileNav()) {
                return;
            }

            if(e.key === 'Escape' || e.keyCode === 27) {
                this.closeDesktopDropdowns();
            }
        };

        // Slide out menu functionality
        this.handleSideMenuAccordion = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const $clickedLink = $(e.currentTarget);
            const targetSelector = $clickedLink.attr('data-target');

            if(!targetSelector) {
                return;
            }

            const $targetDropdown = $(targetSelector);

            if(!$targetDropdown.length) {
                return;
            }

            const $currentNavItem = $clickedLink.closest('.nav-item');
            const dropdownIsOpen = $targetDropdown.hasClass('is-active');

            const $otherDropdowns = $currentNavItem
                .siblings('.nav-item')
                .find('> .dropdown-menu.parent.is-active');

            const $otherLinks = $currentNavItem
                .siblings('.nav-item')
                .find('> a[data-target]');

            $otherDropdowns
                .removeClass('is-active')
                .stop(true, true)
                .slideUp(300);

            $otherLinks.attr('aria-expanded', 'false');

            if(dropdownIsOpen) {
                $targetDropdown
                    .removeClass('is-active')
                    .stop(true, true)
                    .slideUp(300);

                $clickedLink.attr('aria-expanded', 'false');
                this.toggleTabIndex($targetDropdown, -1);

                return;
            }

            $targetDropdown
                .addClass('is-active')
                .stop(true, true)
                .slideDown(300);

            $clickedLink.attr('aria-expanded', 'true');
            this.toggleTabIndex($targetDropdown, 0);
        };

        this.handleProgression = (e) => {

            if(!this.isMobileNav()) {
                this.handleDesktopDropdown(e);
                return;
            }

            const $trigger = $(e.currentTarget);

            if($trigger.is('a[data-target]')) {
                this.handleSideMenuAccordion(e);
                return;
            }

            // Display menu
            objects.$navbarCollapse.addClass('d-block');

            // Pause Slider
            $('.carousel-slides').slick('slickPause');

            // Set active panel levels
            const addActivePanel = () => {
                let thisDropdown = $($(e.target).attr('data-target')).find('.dropdown-menu');

                if($(e.target).attr('data-target') !== undefined) {
                    $($(e.target).attr('data-target')).addClass('is-active');

                    this.toggleTabIndex($($(e.target).attr('data-target')), 0);

                    if(!thisDropdown.hasClass('is-active')) {
                        this.toggleTabIndex(thisDropdown, -1);
                    }
                }
            };

            // Set container offsets & animation
            const setOffset = () => {
                let $thisDropdownWidth;

                // Body Animation
                $('body').addClass('nav-offset');
                $('body').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                    $('body').addClass('nav-offset-reset');
                });

                if(!(utils.getViewportSize() === 'xs' || utils.getViewportSize() === 'sm' || utils.getViewportSize() === 'md')) {
                    $thisDropdownWidth = $(e.target).siblings('.dropdown-menu.parent').outerWidth();

                    // Desktop can keep the original behavior if needed
                    $('.header, #main, .footer').css(
                        'transform', 'translateX(-' + $thisDropdownWidth + 'px)'
                    );
                } else {
                    $thisDropdownWidth = objects.$navbarCollapse.outerWidth();
                    $('[data-current]').removeAttr('data-current');
                    $('[data-previous]').removeAttr('data-previous');

                    if($(e.target).attr('id') !== 'navbarSupportedContent') {
                        $(e.target).attr('data-previous', '');
                        $('[data-previous]').attr('tabindex', -1);
                        $('.navbar-nav > li > a').attr('tabindex', -1);
                        objects.$closebtn.focus();
                    }

                    // Do NOT move the background/page on side menu
                    $('.header, #main, .footer').css('transform', '');

                }
            };

            addActivePanel();
            setOffset();
            this.displayBack();
            utils.initTrapFocus(objects.$navbarCollapse);
        };

        // Remove Offset
        this.removeOffset = () => {
            // Body Animation
            $('body').removeClass('nav-offset');

            // Reset page/background
            $('.header, #main, .footer').css('transform', '');

            // Reset side menu
            // objects.$navbarCollapse.css('transform', '');

            let resetAll = () => {
                $('body').removeClass('nav-offset-reset');
                $('.dropdown-menu').removeClass('is-active').removeAttr('style');
                objects.$navLink.attr('aria-expanded', 'false');
                $('[data-current]').removeAttr('tabindex');
                $('[data-previous]').removeAttr('tabindex');
                $('.navbar-nav > li > a').removeAttr('tabindex');
                $('[data-current]').removeAttr('data-current');
                $('[data-previous]').removeAttr('data-previous');
                objects.$navbarCollapse.removeClass('d-block');
                this.toggleTabIndex(objects.$menuDialogDropdown.filter(':not(.is-active)'), -1);
            };

            setTimeout(resetAll, 320);

            // Play Slider
            $('.carousel-slides').slick('slickPlay');
        };

        this.toggleTabIndex = (el, indexVal) => {
            let tabbableEls = '[href], input, button:not(.btn-close), select, .featured-nav-links .nav-link';

            if(
                utils.getViewportSize() === 'xs' ||
                utils.getViewportSize() === 'sm' ||
                utils.getViewportSize() === 'md'
            ) {
                el.find(tabbableEls).attr('tabindex', indexVal);
            }
        };

        // Populate Persistent Submenu
        this.populateSubmenu = () => {
            objects.$parentLinks.each(function() {
                let $dropdown = $(this).siblings('.dropdown-menu');
                let $childLinks = $dropdown.find('.nav-link');
                let $submenu = $(this).siblings('.persistent-submenu');

                $childLinks.each(function() {
                    $(this).attr('href', $(this).data('url'));
                });

                let cloned = $childLinks.clone().removeAttr(
                    'role data-toggle data-target aria-haspopup aria-expanded aria-controls'
                );

                $submenu.append(cloned).wrapInner('<div class="container"></div>');
            });
        };

        // Mobile Only
        this.displayMobileMenu = (e) => {
            if($(e.target).attr('id') === 'navbarSupportedContent') {
                this.handleProgression(e);
            }
        };

        this.displayBack = (progressionStarted) => {
            if($('.dropdown-menu').hasClass('is-active')) {
                objects.$backbtnIcon.addClass('d-block');
                objects.$backbtn.attr('tabindex', 0);
            } else {
                objects.$backbtnIcon.removeClass('d-block');
                objects.$backbtn.attr('tabindex', -1);
            }

            if(progressionStarted) {
                objects.$closebtn.focus();
            }
        };

        this.handleBack = () => {
            $('[data-current]').removeAttr('data-current');
            $($('[data-previous]').data('target')).removeClass('is-active');
            $('[data-previous]').removeAttr('tabindex');
            $('[data-current]').removeAttr('tabindex');
            $('.navbar-nav > li > a').removeAttr('tabindex');
            this.toggleTabIndex($($('[data-previous]').data('target')), -1);
            $('[data-previous]').removeAttr('data-previous').attr('data-current', '');
            let currentDropdownId = $('[data-current]').parents('.dropdown-menu').attr('id');
            $('[data-target="' + ('#' + currentDropdownId) + '"]').attr('data-previous', '');
            this.displayBack(true);
        };

        this.replaceBreadcrumb = () => {
            let $productPageBreadCrumb = $('.product-page-breadcrumb');

            if($productPageBreadCrumb.length > 0) {
                $('.breadcrumb-item').html($productPageBreadCrumb.html());
            }
        };

        // Utils' setSticky swaps a sticky element from its in-flow position to fixed when
        // the first scroll event lands. Chrome scrolls on the compositor and paints that
        // scrolled frame before the handler runs, so the element is drawn one frame's
        // worth of scroll out of place and then snaps back - the small bounce on first
        // scroll that Firefox never shows, because it does not paint the intermediate
        // frame.
        //
        // Where an element already rests at the offset it would pin to there is no travel
        // to preserve, so it can just be fixed from the start and the swap disappears.
        // Applied to the header and to the banner above it: they are one visual stack (the
        // header's pinned offset is the banner's height), so a bounce in either one reads
        // as the header bouncing.
        //
        // Anything that does have real travel is left entirely alone - it keeps
        // data-set-sticky and Utils handles it exactly as before, with no new code in its
        // path. That covers the product matrix toggle bars, and the header itself on pages
        // where an alert bar sits above it. The handoff, and its one frame of lag, stays
        // on those by design; removing it there needs the element in flow with
        // position: sticky, which is a layout change rather than this fix.
        this.getStickyPinnedTop = ($el) => {
            const $offsetSource = $($el.data('additional-offset'));

            return $offsetSource.length ? Math.abs($offsetSource.height()) : 0;
        };

        // Measured in the resting state, so a pin from an earlier pass has to come off
        // first - the inline position and the spacer standing in for it - or we would
        // just measure the pinned position back.
        this.getStickyRestingOffset = ($el) => {
            const wasPinned = $el.data('sticky-pinned');

            if(wasPinned) {
                $el.css({ position: '', top: '' });
                this.setStickySpacerHeight($el, 0);
            }

            const restingOffset = $el.offset().top;

            if(wasPinned) {
                $el.css({ position: 'fixed', top: this.getStickyPinnedTop($el) + 'px' });
                this.setStickySpacerHeight($el, $el.height());
            }

            return restingOffset;
        };

        // A pinned element is out of flow, so anything standing in for it has to hold its
        // height - the same thing Utils' setSticky does for data-spacer-content.
        this.setStickySpacerHeight = ($el, height) => {
            const spacerSelector = $el.data('spacer-content');

            if(spacerSelector) {
                $(spacerSelector).css('height', height);
            }
        };

        // Alert.js expands #site-alert / #consent-alert shortly after load when its
        // dismissal has not been stored, which pushes the stack down and gives the header
        // real travel before it pins. It reads that from storage, so read the same thing
        // and decide once, up front, against the layout the page is about to settle into
        // rather than the collapsed one it starts in.
        //
        // Deciding once matters. An earlier version re-decided when an alert opened or
        // closed and handed the element back to Utils, but Utils records an offset when it
        // takes an element on and only re-measures on resize - so handing back while the
        // alert was open froze an offset an alert's height too low, which then delayed
        // pinning by that much and dropped the spacer in mid-scroll as a jump. Utils'
        // per-element scroll handler also cannot be unbound, so pinning again afterwards
        // left the two fighting over every scroll.
        this.hasUndismissedAlert = () => {
            return $('[data-module="Alert"]').toArray().some((el) => {
                const $alert = $(el);
                const key = $alert.data('cookie');

                if(!key) {
                    return false;
                }

                const ttl = parseInt($alert.data('cookie-ttl'), 10);

                try {
                    if(isNaN(ttl) || ttl <= 0) {
                        return !sessionStorage.getItem(key);
                    }

                    const stored = localStorage.getItem(key);

                    if(stored === null) {
                        return true;
                    }

                    // Matching Alert.js: a stored item past its expiration counts as absent.
                    const expiration = JSON.parse(stored).expiration;

                    return expiration == null || new Date(expiration) <= new Date();
                } catch(e) {
                    // Storage can be unavailable. Assume the alert will show, which just
                    // leaves the element on the path it was always on.
                    return true;
                }
            });
        };

        this.watchStickyPin = ($el) => {
            if(!$el.length || !$el.is('[data-set-sticky]')) {
                return;
            }

            const pinnedTop = this.getStickyPinnedTop($el);

            // Sub-pixel offsets are normal here, so compare with a tolerance rather than
            // for equality.
            if(Math.abs(this.getStickyRestingOffset($el) - pinnedTop) >= 1) {
                return;
            }

            // Taking the element off Utils' books before initSetSticky runs, so it is
            // never measured or moved there. is-persistent still rides the scroll, since
            // on the header it drives how the bar looks rather than where it sits.
            $el
                .removeAttr('data-set-sticky')
                .data('sticky-pinned', true)
                .css({ position: 'fixed', top: pinnedTop + 'px' });

            this.setStickySpacerHeight($el, $el.height());

            const applyPersistentClass = () => {
                $el.toggleClass('is-persistent', $(window).scrollTop() > 0);
            };

            applyPersistentClass();
            $(window).on('scroll', applyPersistentClass);

            // Nothing can start occupying space above a pinned element - every alert on
            // the page was already dismissed for us to get here - but the banner can
            // rewrap to a different height, so keep the offset and the spacer in step.
            $(window).on('resize', utils.debounce(() => {
                const nextPinnedTop = this.getStickyPinnedTop($el);

                $el.css('top', nextPinnedTop + 'px');
                this.setStickySpacerHeight($el, $el.height());
            }, 250, false));
        };

        // The banner goes first: it is what the header measures its pinned offset
        // against, and pinning it swaps its own height for the spacer's, so the header
        // has to be measured against the settled layout.
        this.pinHeaderStack = () => {
            if(this.hasUndismissedAlert()) {
                return;
            }

            this.watchStickyPin($(objects.$el.data('additional-offset')));
            this.watchStickyPin(objects.$el);
        };

        // Init
        this.Header = () => {

            window.onscroll = function(e) {
                if(this.oldScroll > this.scrollY) {
                    objects.$el.addClass('scroll-up');
                } else {
                    objects.$el.removeClass('scroll-up');
                }

                this.oldScroll = this.scrollY;
            };

            // Mobile keeps click behavior.
            // Desktop prevents the click from opening the old sidebar/collapse behavior.
            objects.$navLink.on('click', (e) => {
                if(this.isMobileNav()) {
                    this.handleProgression(e);
                    return;
                }

                e.preventDefault();
                e.stopPropagation();
            });

            // Desktop opens only from top-level nav links on hover/focus.
            objects.$el.find('ul.navbar-nav > li.nav-item > a[data-target]').on('mouseenter focusin', (e) => {
                if(!this.isMobileNav()) {
                    this.handleDesktopDropdown(e);
                }
            });

            // Keep desktop dropdown open while moving between the nav and dropdown.
            objects.$el.find('ul.navbar-nav > li.nav-item > a[data-target], .dropdown-menu.parent').on('mouseenter mousemove', () => {
                if(!this.isMobileNav()) {
                    this.clearDesktopCloseTimer();
                }
            });

            objects.$backbtn.on('click', this.handleBack);

            // ADA tabindex set
            if(
                utils.getViewportSize() === 'xs' ||
                utils.getViewportSize() === 'sm' ||
                utils.getViewportSize() === 'md'
            ) {
                this.toggleTabIndex(objects.$menuDialogDropdown.filter(':not(.is-active)'), -1);
                objects.$backbtn.attr('tabindex', -1);
                $('.dropdown-menu.parent').find('.btn-close').attr('tabindex', -1);
                $('.persistent-search-toggle .search-toggler').attr('tabindex', -1);
            }

            // Remove tabbing from inactive elements on desktop
            if(
                !(
                    utils.getViewportSize() === 'xs' ||
                    utils.getViewportSize() === 'sm' ||
                    utils.getViewportSize() === 'md'
                )
            ) {
                $('.dropdown-menu.parent').find('[data-toggle="collapse"]').attr('tabindex', -1);
            }

            // Menu toggle
            $('.header .collapse').on('show.bs.collapse', (e) => {
                this.displayMobileMenu(e);
            });

            objects.$navbarCollapse.on('show.bs.collapse', function() {
                $(this)
                    .removeClass('side-menu-closing side-menu-open')
                    .addClass('side-menu-opening');
            });

            objects.$navbarCollapse.on('shown.bs.collapse', function() {
                $(this)
                    .removeClass('side-menu-opening side-menu-closing')
                    .addClass('side-menu-open');
            });

            objects.$navbarCollapse.on('hide.bs.collapse', function() {
                $(this)
                    .removeClass('side-menu-opening side-menu-open')
                    .addClass('side-menu-closing');
            });

            objects.$navbarCollapse.on('hidden.bs.collapse', function() {
                $(this)
                    .removeClass('side-menu-opening side-menu-closing side-menu-open');
            });

            objects.$menuDialog.on('shown.bs.collapse', (e) => {
                utils.initTrapFocus($(e.target));
            });

            let overlayHoverScheduled = false;
            let lastOverlayHoverEvent = null;
            
            $(document).on('mousemove', (e) => {
                lastOverlayHoverEvent = e;
            
                if(overlayHoverScheduled) {
                    return;
                }
            
                overlayHoverScheduled = true;
            
                requestAnimationFrame(() => {
                    overlayHoverScheduled = false;
                    this.handleDesktopOverlayHover(lastOverlayHoverEvent);
                });
            });
            
            // Close desktop dropdown when the pointer leaves the window entirely
            $(document).on('mouseleave', this.handleDesktopPointerLeave);

            $(window).on('blur', () => {
                this.handleDesktopPointerLeave();
            });

            // Close desktop dropdown with ESC
            $(document).on('keydown', this.handleDesktopEscClose);

            // Nav item positions and the panel's pinned offset can shift on resize or on
            // scroll (sticky header transitions). Just nulling the cache here is O(1); the
            // actual re-measurement is deferred to the next mousemove that needs it.
            $(window).on('resize', () => {
                this.invalidateDesktopMenuGapBounds();
            });
            
            $(window).on('scroll', () => {
                this.invalidateDesktopMenuGapBounds();
            });
            
            // Reset container offsets & animation
            $(document).on('click', (e) => {
                const clickedOutsideHeader = !$(e.target).parents().is(objects.$el);
                const clickedCloseButton = $(e.target).parents().is(objects.$closebtn) || $(e.target).is(objects.$closebtn);

                if(clickedOutsideHeader || clickedCloseButton) {
                    if(this.isMobileNav()) {
                        this.removeOffset();
                        $('#navbarSupportedContent').collapse('hide');
                    } else {
                        this.closeDesktopDropdowns();
                    }
                }
            });

            // Header Search toggle
            $(document).on('click', (e) => {
                if(!$(e.target).is(objects.$searchInput) && !$(e.target).parents().is(objects.$headerSearch)) {
                    objects.$headerSearch.collapse('hide');
                    objects.$searchInput.removeClass('active');
                }
            });

            objects.$searchInput.on('change keyup', (e) => {
                let valLength = $(e.target).val().length;

                if(valLength > 0) {
                    $(e.target).addClass('active');
                } else {
                    $(e.target).removeClass('active');
                }
            });
            
            objects.$navList.on('focusout', this.handleDesktopFocusOut);

            objects.$headerSearch.on('submit', (e) => {
                const searchVal = objects.$searchInput.val().trim();

                if(searchVal.length <= 0) {
                    e.preventDefault();
                    return;
                }

                const $container = $('#search-suggestions-wrapper');

                if(!$container.length) {
                    return;
                }

                let $active = $container.find(
                    '.parts-results.is-active, ' +
                    '.suggestions-results-details.is-active, ' +
                    '.view-all-option.is-active, ' +
                    '.see-more-option.is-active'
                );

                // Fallback: hovered item if nothing is active
                if(!$active.length) {
                    $active = $container.find(
                        '.parts-results:hover, ' +
                        '.suggestions-results-details:hover, ' +
                        '.view-all-option:hover, ' +
                        '.see-more-option:hover'
                    );
                }

                // If we have something selected active/hovered, override default submit
                if($active.length) {
                    e.preventDefault();

                    const $item = $active.first();

                    if($item.hasClass('see-more-option')) {
                        if(objects.$headerSearch[0]) {
                            objects.$headerSearch[0].submit();
                        }

                        return;
                    }

                    if($item.hasClass('view-all-option')) {
                        const $link = $item.find('a[href]').first();

                        if($link.length) {
                            window.location.href = $link.attr('href');
                            return;
                        }
                    }

                    const $link = $item.find('a[href]').first();

                    if($link.length) {
                        window.location.href = $link.attr('href');
                        return;
                    }

                    if(objects.$headerSearch[0]) {
                        objects.$headerSearch[0].submit();
                    }

                    return;
                }
            });

            objects.$searchCategories.on('click', (e) => {
                let $this = $(e.target);

                objects.$headerSearch.find('input[name="cat"]').val($this.data('category'));
                objects.$headerSearch.submit();
            });

            $('.form-fields-hny').attr('tabindex', -1);

            objects.$headerSearch.on('show.bs.collapse', (e) => {
                // Immediately close desktop dropdown when search opens
                if(!this.isMobileNav()) {
                    this.closeDesktopDropdownsImmediately();
                }

                $('.search-backdrop').removeClass('d-none');
                $('#searchTerm').focus();
                $('.search-wrapper').removeClass('contract').addClass('expanded');
                objects.$headerSearch.removeClass('header-search-hidden');
            });

            objects.$headerSearch.on('shown.bs.collapse', function() {
                $('#searchTerm').val('');
                $('#searchTermMobile').val('');
                $('#searchTerm').focus();
            });

            objects.$headerSearch.on('hide.bs.collapse', function(e) {
                e.preventDefault();

                $('.search-backdrop').addClass('d-none');
                $('.search-toggler:visible').focus();
                $('#searchTerm').val('');
                $('#searchTermMobile').val('');
                $('#search-suggestions-wrapper').remove();
                $('.no-results-container').remove();
                $('.no-results-dropdown').remove();
                $('.no-suggestions-container').remove();

                // Trigger the contract animation
                $('.search-wrapper').removeClass('expanded').addClass('contract');

                // Listen for the end of the animation to hide the search form
                $('.search-wrapper').one('animationend', function() {
                    $('.search-wrapper').removeClass('contract');
                    objects.$headerSearch.removeClass('show').addClass('header-search-hidden');
                });
            });

            // Populate & Activate Persistent Submenu
            this.populateSubmenu();

            this.pinHeaderStack();

            utils.initSetSticky();

            this.replaceBreadcrumb();
        };
    }

    init() {
        this.Header();
    }
}

export default Header;

